import { render, staticRenderFns } from "./DSTrashIcon.vue?vue&type=template&id=1384c9cc&scoped=true&"
import script from "./DSTrashIcon.vue?vue&type=script&lang=js&"
export * from "./DSTrashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1384c9cc",
  null
  
)

export default component.exports